import { Link } from 'react-router-dom';
import SectionHeader from '@/components/base/SectionHeader';
import { dramas } from '@/mocks/dramas';
import { TIMELINE_META } from '@/utils/drama';

export default function LatestUpdates() {
  const feed = dramas
    .flatMap((drama) =>
      drama.timeline.map((entry) => ({
        dramaId: drama.id,
        dramaTitle: drama.title,
        date: entry.date,
        title: entry.title,
        type: entry.type,
      })),
    )
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 6);

  return (
    <section className="px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeader
          eyebrow="更新日志"
          title="最近新增的时间线节点"
          description="反转、续集与结局都记在这里，按日期倒序排列。"
          action={
            <Link
              to="/dramas"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              去瓜田看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200">
          {feed.map((item, index) => {
            const meta = TIMELINE_META[item.type];
            return (
              <Link
                key={`${item.dramaId}-${item.date}-${index}`}
                to={`/drama/${item.dramaId}`}
                className={`flex flex-col gap-2 px-4 py-4 transition-colors hover:bg-background-100 sm:flex-row sm:items-center sm:gap-5 md:px-6 ${
                  index % 2 === 0 ? 'bg-background-50' : 'bg-background-100/60'
                }`}
              >
                <time className="w-28 shrink-0 font-heading text-sm text-foreground-500">
                  {item.date}
                </time>
                <span
                  className={`inline-flex w-fit items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium ${meta.badgeClass}`}
                >
                  <i className={`${meta.icon} text-sm`}></i>
                  {meta.label}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm text-foreground-900">
                  {item.title}
                </span>
                <span className="min-w-0 max-w-[220px] truncate text-xs text-foreground-500">
                  《{item.dramaTitle}》
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}